interface BulkActionsBarProps {
  count: number;
  disabled: boolean;
  onCreateShipments: () => void;
  onDelete: () => void;
  onClear: () => void;
}

/** Dark strip that slides in over the address list when rows are selected. */
function BulkActionsBar({ count, disabled, onCreateShipments, onDelete, onClear }: BulkActionsBarProps) {
  return (
    <div className="bulk-bar">
      <span className="sel">{count} selected</span>
      <div className="bulk-actions">
        <button type="button" className="btn-onink accent" onClick={onCreateShipments} disabled={disabled}>
          Create shipments
        </button>
        <button type="button" className="btn-onink" onClick={onDelete} disabled={disabled}>
          Delete
        </button>
        <button type="button" className="btn-onink ghost" onClick={onClear} disabled={disabled}>
          Clear
        </button>
      </div>
    </div>
  );
}

export default BulkActionsBar;
